{
  "creating_subtitle": "Detta tar bara en stund",
  "creating_account": "Skapar ditt konto...",
  "error_title": "Hoppsan! Något gick fel",
  "try_again": "Försök igen",
  "first_name_label": "Förnamn",
  "first_name_placeholder": "Ange ditt förnamn",
  "error_generic": "Något gick fel. Försök igen.",
  "create_user_failed": "Det gick inte att skapa användarkontot.",
  "missing_name_title": "Vad heter du?",
  "missing_name_subtitle": "Vi behöver ditt förnamn för att slutföra skapandet av ditt konto.",
  "missing_name_continue": "Fortsätt"
}
